export default {"src":"/assets/turbo/b87d0112/lascananl/_next/static/media/favicon.003cb33d.ico","height":192,"width":192,"blurWidth":0,"blurHeight":0};